<template>
  <div>
    <el-form-item label="Template" prop="template">
      <el-select class="template-dropdown" popper-class="template-dropdown-popper" v-model="selectedTemplate"
        placeholder="Choose template" clearable @change="onSelectedTemplateChange">
        <el-option label="None" value="" />
        <el-option v-for="template in templates" :key="template" :label="template" :value="template" />
      </el-select>
    </el-form-item>
    <el-form-item v-show="showPreparerSignatureField" label="Preparer Signature" prop="signature">
      <el-input v-model="preparerSignature" />
    </el-form-item>
    <el-alert v-if="selectedTemplate && parsedTemplate.warnings && parsedTemplate.warnings.length > 0"
      :title="parsedTemplate.warnings.join(', ')" type="warning" show-icon />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DocutaxClient } from '@/model';

const PLACEHOLDER = {
  CLIENT_FIRST_NAME: '%%client_first_name%%',
  PREPARER_SIGNATURE: '%%preparer_signature%%',
};

export default {
  props: {
    docutaxClient: {
      type: Object,
      default: () => new DocutaxClient(),
    },
  },
  data() {
    return {
      selectedTemplate: undefined,
      preparerSignature: undefined,
      templates: [
        `${PLACEHOLDER.CLIENT_FIRST_NAME} please respond to this message with a copy of your drivers license, social, and any income documents you may have. Thank you! ${PLACEHOLDER.PREPARER_SIGNATURE}`,
        `${PLACEHOLDER.CLIENT_FIRST_NAME} please respond to this secured link with a picture of your ID along with any income documents you may have to file your taxes. Thank you! ${PLACEHOLDER.PREPARER_SIGNATURE}`,
      ],
    };
  },
  watch: {
    preparerSignature() {
      if (this.showPreparerSignatureField) {
        this.publishChange();
      }
    },
    docutaxClient: {
      deep: true,
      handler() {
        this.publishChange();
      },
    },
  },
  computed: {
    ...mapGetters('User', ['user']),
    parsedTemplate() {
      const warnings = [];
      if (!this.selectedTemplate || !this.selectedTemplate.length) {
        return {
          value: undefined,
          warnings,
        };
      }

      let parsedTemplate = this.selectedTemplate;
      Object.values(PLACEHOLDER).forEach((placeholder) => {
        if (parsedTemplate.includes(placeholder)) {
          const value = this.getValueForPlaceholder(placeholder);
          if (!value || !value.length) {
            parsedTemplate = parsedTemplate.replaceAll(placeholder, '');
            warnings.push(`${placeholder} - No value specified`);
          } else {
            parsedTemplate = parsedTemplate.replaceAll(placeholder, value);
          }
        }
      });

      return {
        value: parsedTemplate.trim(),
        warnings,
      };
    },
    showPreparerSignatureField() {
      return this.selectedTemplate && this.selectedTemplate.includes(PLACEHOLDER.PREPARER_SIGNATURE);
    },
    preparerSignatureLocalStorageKey() {
      const userKey = this.user && this.user.id ? this.user.id : 'anonymous';
      return `docutax-request-preparer-signature-${userKey}`;
    },
  },
  methods: {
    onSelectedTemplateChange() {
      console.info('template changed', this.selectedTemplate);

      if (!this.selectedTemplate) {
        this.$emit('clear');
        return;
      }

      this.publishChange();
    },
    getValueForPlaceholder(placeholder) {
      switch (placeholder) {
        case PLACEHOLDER.CLIENT_FIRST_NAME:
          return this.docutaxClient.firstName;
        case PLACEHOLDER.PREPARER_SIGNATURE:
          return this.preparerSignature;
        default:
          return undefined;
      }
    },
    publishChange() {
      if (!this.selectedTemplate) {
        return;
      }

      if (this.showPreparerSignatureField) {
        window.localStorage.setItem(this.preparerSignatureLocalStorageKey, this.preparerSignature);
      }

      this.$emit('change', this.parsedTemplate.value);
    },
  },
  created() {
    if (this.user) {
      const signature = window.localStorage.getItem(this.preparerSignatureLocalStorageKey);
      if (signature && signature.length) {
        this.preparerSignature = signature;
      }
    }
  },
};
</script>

<style lang="scss">
el-select.template-dropdown {
  width: 100%;
}

.template-dropdown-popper {
  max-width: 500px;

  .el-select-dropdown__item {
    line-height: 1.2em;
    height: auto;
    white-space: normal;
    padding: 12px;
  }
}
</style>
